export var EnumReportTypes = /*#__PURE__*/ function (EnumReportTypes) {
    EnumReportTypes[EnumReportTypes["SummaryReport"] = 1] = "SummaryReport";
    EnumReportTypes[EnumReportTypes["AccountBalancesReport"] = 2] = "AccountBalancesReport";
    EnumReportTypes[EnumReportTypes["DiagramReport"] = 3] = "DiagramReport";
    EnumReportTypes[EnumReportTypes["ExchangeVolumeReport"] = 4] = "ExchangeVolumeReport";
    return EnumReportTypes;
}({});
